import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, fontWeights }: Theme) => ({
  title: {
    margin: '0 0 1.5rem',
    fontSize: '1.25rem',
    lineHeight: 1.4,
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      marginBottom: '0.5rem',
      fontSize: '1.75rem',
    },
  },
  text: {
    '& + p': {
      marginTop: '0.5rem',
    },
  },
  strong: {
    fontWeight: fontWeights.medium,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    marginTop: '1.5rem',
    [breakpoints.up('md')]: {
      marginTop: '2rem',
    },
  },
  image: {
    position: 'relative',
    marginBottom: '1.5rem',
    lineHeight: 0,
    [breakpoints.up('md')]: {
      marginBottom: '2rem',
    },
    '& img': {
      maxWidth: '100%',
    },
  },
  paperStyles: {
    paddingTop: 0,
    paddingBottom: '1.5rem',
    borderRadius: '0.5rem',
    [breakpoints.up('md')]: {
      width: '34.875rem',
      paddingBottom: '3rem',
    },
  },
}));
